module.exports = __webpack_public_path__ + "static/media/Placeholder.94a042df.svg";